import { useState } from 'react';
import LocationDropdown from './LocationDropdown';
import axiosInstance from '@/utils/https';
import LocationWarning from './LocationWarning';

type Prop = {
  setState: (state: string) => void;
  state: string;
  setCity: (city: string) => void;
  city: string;
  setBranch: (branch: string) => void;
  branch: string;
  setBranches: (branches: any[]) => void;
  setShowWarning: (showWarning: boolean) => void;
};

export default function LocationDetails({
  setState,
  state,
  setCity,
  city,
  setBranch,
  branch,
  setBranches,
  setShowWarning,
}: Prop) {
  const [cities, setCities] = useState<string[]>([]);
  const [fetchingCity, setFetchingCity] = useState<boolean>(false);
  const [fetchingOutlets, setFetchingOutlets] = useState<boolean>(false);
  const [branchesName, setBranchesName] = useState<string[]>([]);
  const [branchesStatus, setBranchesStatus] = useState<{ name: string; status: string }[]>(
    []
  );

  const states = [
    'Abia',
    'Adamawa',
    'Akwa Ibom',
    'Anambra',
    'Bauchi',
    'Bayelsa',
    'Benue',
    'Borno',
    'Cross River',
    'Delta',
    'Ebonyi',
    'Edo',
    'Ekiti',
    'Enugu',
    'Gombe',
    'Imo',
    'Jigawa',
    'Kaduna',
    'Kano',
    'Katsina',
    'Kebbi',
    'Kogi',
    'Kwara',
    'Lagos',
    'Nasarawa',
    'Niger',
    'Ogun',
    'Ondo',
    'Osun',
    'Oyo',
    'Plateau',
    'Rivers',
    'Sokoto',
    'Taraba',
    'Yobe',
    'Zamfara',
    'FCT',
  ];

  const handleGetCity = async (state: string) => {
    try {
      setFetchingCity(true);
      const url = `api/v1/outlets/cities?states=${state.toLocaleLowerCase()}`;
      const response = await axiosInstance.get(url);
      if (response.data.length === 0) {
        setShowWarning(true);
      } else {
        setShowWarning(false);
      }
      setCities(response.data);
      setFetchingCity(false);
    } catch (error) {
      console.log(error);
      setFetchingCity(false);
    }
  };

  const handlegetBranch = async (state: string, city: string) => {
    try {
      setFetchingOutlets(true);
      const url = `api/v1/outlets/location/${state.toLocaleLowerCase()}/${city.toLocaleLowerCase()}`;
      const response = await axiosInstance.get(url);
      setBranches(response.data);
      setBranchesName(response.data.map((branch: any) => branch.name));
      setBranchesStatus(response.data.map((branch: any) => ({ name: branch.name, status: branch.business_status })));
      setFetchingOutlets(false);
    } catch (error) {
      console.log(error);
      setFetchingOutlets(false);
    }
  };
  const filledCount = (state ? 1 : 0) + (city ? 1 : 0) + (branch ? 1 : 0);

  const progressWidth =
    filledCount === 0
      ? 'w-[0%]'
      : filledCount === 1
        ? 'w-[33.33%]'
        : filledCount === 2
          ? 'w-[66.67%]'
          : 'w-full';
  return (
    <>
      <div className="sticky top-0 bg-white z-10">
        <h1 className="font-medium text-[20px] mb-4">
          Where are you ordering from?
        </h1>

        <div className="flex items-center justify-between mb-4 text-center text-sm text-gray-600 font-medium">
          <div className="flex-1">
            <div
              className={`${filledCount >= 1 && 'bg-[#E90C31] text-white'} w-8 h-8 mx-auto rounded-full border border-gray-400 flex items-center justify-center`}
            >
              {filledCount >= 1 ? '✓' : '1'}
            </div>
            <p className="text-[10px] font-medium">Select state</p>
          </div>
          <div className="flex-1">
            <div
              className={`${filledCount >= 2 && 'bg-[#E90C31] text-white'} w-8 h-8 mx-auto rounded-full border border-gray-400 flex items-center justify-center`}
            >
              {filledCount >= 2 ? '✓' : '2'}
            </div>
            <p className="text-[10px] font-medium">Select city</p>
          </div>
          <div className="flex-1">
            <div
              className={`${filledCount === 3 && 'bg-[#E90C31] text-white'} w-8 h-8 mx-auto rounded-full  border border-gray-400 flex items-center justify-center`}
            >
              {filledCount === 3 ? '✓' : '3'}
            </div>
            <p className="text-[10px] font-medium">Select branch</p>
          </div>
        </div>

        <div className="w-full h-1 bg-[#D4DCE8] rounded-md">
          <div
            className={`${progressWidth} bg-[#E90C31] h-full rounded-md transition-all duration-300`}
          ></div>
        </div>
      </div>

      <LocationDropdown
        label="State"
        options={states}
        value={state}
        onChange={(val: string) => {
          handleGetCity(val);
          setState(val);
          setCity('');
          setBranch('');
        }}
      />

      <LocationDropdown
        label="City"
        options={cities || []}
        value={city}
        disabled={!state}
        onChange={(val: string) => {
          handlegetBranch(state, val);
          setCity(val);
          setBranch('');
        }}
        loading={fetchingCity}
      />

      <LocationDropdown
        label="Outlet"
        options={branchesName || []}
        value={branch}
        onChange={(val: string) => {
          setBranch(val);
        }}
        disabled={!city}
        loading={fetchingOutlets}
        outletsStatus={branchesStatus}
      />
    </>
  );
}
